import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import TeamSection from './TeamSection';

export default class Club extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    active: PropTypes.bool,
    id: PropTypes.string,
    toggleSection: PropTypes.func,
  };
  render() {
    const {icon, placement, points, team, key, teamlist} = this.props.data;
    const {active, id, toggleSection} = this.props;
    const clubItemClass = classNames(`club-item ${key}`, {active});
    return (
      <section className={clubItemClass}>
        <div className="row">
          <div className="col-xs-12">
            <div id={id} onClick={toggleSection} role="presentation" className="header">
              <h2 className="placement text-center">{placement}</h2>
              <img src={icon} className="img-responsive" alt={team} />
              <h2>{team}</h2>
              <h3>{points}</h3>
              <i className="icon-arrow" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="teamContainer">
              <TeamSection list={teamlist} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
